/*
Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/
import { css } from '@spectrum-web-components/base';
const styles = css `
:host([size=s]){--spectrum-statuslight-info-text-font-weight:var(
--spectrum-statuslight-info-s-text-font-weight,var(--spectrum-alias-body-text-font-weight)
);--spectrum-statuslight-info-text-line-height:var(
--spectrum-statuslight-info-s-text-line-height,var(--spectrum-alias-component-text-line-height)
);--spectrum-statuslight-info-text-size:var(
--spectrum-statuslight-info-s-text-size,var(--spectrum-alias-item-text-size-s)
);--spectrum-statuslight-info-dot-size:var(
--spectrum-statuslight-info-s-dot-size,var(--spectrum-alias-item-control-1-size-s)
);--spectrum-statuslight-info-text-gap:var(
--spectrum-statuslight-info-s-text-gap,var(--spectrum-alias-item-control-gap-s)
);--spectrum-statuslight-info-height:var(
--spectrum-statuslight-info-s-height,var(--spectrum-alias-item-height-s)
)}:host([size=m]){--spectrum-statuslight-info-text-font-weight:var(
--spectrum-statuslight-info-m-text-font-weight,var(--spectrum-alias-body-text-font-weight)
);--spectrum-statuslight-info-text-line-height:var(
--spectrum-statuslight-info-m-text-line-height,var(--spectrum-alias-component-text-line-height)
);--spectrum-statuslight-info-text-size:var(
--spectrum-statuslight-info-m-text-size,var(--spectrum-alias-item-text-size-m)
);--spectrum-statuslight-info-dot-size:var(
--spectrum-statuslight-info-m-dot-size,var(--spectrum-alias-item-control-1-size-m)
);--spectrum-statuslight-info-text-gap:var(
--spectrum-statuslight-info-m-text-gap,var(--spectrum-alias-item-control-gap-m)
);--spectrum-statuslight-info-height:var(
--spectrum-statuslight-info-m-height,var(--spectrum-alias-item-height-m)
)}:host([size=l]){--spectrum-statuslight-info-text-font-weight:var(
--spectrum-statuslight-info-l-text-font-weight,var(--spectrum-alias-body-text-font-weight)
);--spectrum-statuslight-info-text-line-height:var(
--spectrum-statuslight-info-l-text-line-height,var(--spectrum-alias-component-text-line-height)
);--spectrum-statuslight-info-text-size:var(
--spectrum-statuslight-info-l-text-size,var(--spectrum-alias-item-text-size-l)
);--spectrum-statuslight-info-dot-size:var(
--spectrum-statuslight-info-l-dot-size,var(--spectrum-alias-item-control-1-size-l)
);--spectrum-statuslight-info-text-gap:var(
--spectrum-statuslight-info-l-text-gap,var(--spectrum-alias-item-control-gap-l)
);--spectrum-statuslight-info-height:var(
--spectrum-statuslight-info-l-height,var(--spectrum-alias-item-height-l)
)}:host([size=xl]){--spectrum-statuslight-info-text-font-weight:var(
--spectrum-statuslight-info-xl-text-font-weight,var(--spectrum-alias-body-text-font-weight)
);--spectrum-statuslight-info-text-line-height:var(
--spectrum-statuslight-info-xl-text-line-height,var(--spectrum-alias-component-text-line-height)
);--spectrum-statuslight-info-text-size:var(
--spectrum-statuslight-info-xl-text-size,var(--spectrum-alias-item-text-size-xl)
);--spectrum-statuslight-info-dot-size:var(
--spectrum-statuslight-info-xl-dot-size,var(--spectrum-alias-item-control-1-size-xl)
);--spectrum-statuslight-info-text-gap:var(
--spectrum-statuslight-info-xl-text-gap,var(--spectrum-alias-item-control-gap-xl)
);--spectrum-statuslight-info-height:var(
--spectrum-statuslight-info-xl-height,var(--spectrum-alias-item-height-xl)
)}:host([dir]){--spectrum-statuslight-info-padding-y:var(
--spectrum-global-dimension-size-65
);--spectrum-statuslight-info-text-line-height:1.44;--spectrum-statuslight-info-padding-top:calc(var(--spectrum-statuslight-info-padding-y) - 1px);--spectrum-statuslight-info-padding-bottom:calc(var(--spectrum-statuslight-info-padding-y) + 1px)}:host([dir]){align-items:flex-start;box-sizing:border-box;display:flex;flex-direction:row;font-size:var(--spectrum-statuslight-info-text-size);font-weight:var(--spectrum-statuslight-info-text-font-weight);line-height:var(--spectrum-statuslight-info-text-line-height);min-height:var(
--spectrum-statuslight-info-height
);padding-bottom:var(--spectrum-statuslight-info-padding-bottom);padding-left:0;padding-right:0;padding-top:var(--spectrum-statuslight-info-padding-top)}:host:before{-ms-high-contrast-adjust:none;border-radius:50%;content:"";display:inline-block;flex-grow:0;flex-shrink:0;forced-color-adjust:none;height:var(--spectrum-statuslight-info-dot-size);margin:var(--spectrum-statuslight-info-padding-bottom) var(--spectrum-statuslight-info-text-gap) var(--spectrum-statuslight-info-padding-top);width:var(--spectrum-statuslight-info-dot-size)}:host([variant=neutral]){font-style:italic}:host([dir]){color:var(
--spectrum-statuslight-info-m-text-color,var(--spectrum-alias-text-color)
)}:host([disabled]){color:var(
--spectrum-statuslight-info-m-text-color-disabled,var(--spectrum-alias-text-color-disabled)
)}:host([disabled]):before{background-color:var(
--spectrum-statuslight-info-m-dot-color-disabled,var(--spectrum-global-color-gray-400)
)}:host([variant=negative]):before{background-color:var(
--spectrum-statuslight-negative-m-dot-color,var(--spectrum-semantic-negative-color-status)
)}:host([variant=notice]):before{background-color:var(
--spectrum-statuslight-notice-m-dot-color,var(--spectrum-semantic-notice-color-status)
)}:host([variant=positive]):before{background-color:var(
--spectrum-statuslight-positive-m-dot-color,var(--spectrum-semantic-positive-color-status)
)}:host([active]):before,:host([variant=info]):before{background-color:var(
--spectrum-statuslight-info-m-dot-color,var(--spectrum-semantic-informative-color-status)
)}:host([variant=neutral]){color:var(
--spectrum-statuslight-neutral-m-text-color,var(--spectrum-alias-label-text-color)
)}:host([variant=neutral]):before{background-color:var(
--spectrum-statuslight-neutral-m-dot-color,var(--spectrum-global-color-gray-500)
)}:host([variant=celery]):before{background-color:var(
--spectrum-statuslight-celery-m-dot-color,var(--spectrum-global-color-celery-400)
)}:host([variant=yellow]):before{background-color:var(
--spectrum-statuslight-yellow-m-dot-color,var(--spectrum-global-color-yellow-400)
)}:host([variant=fuchsia]):before{background-color:var(
--spectrum-statuslight-fuchsia-m-dot-color,var(--spectrum-global-color-fuchsia-400)
)}:host([variant=indigo]):before{background-color:var(
--spectrum-statuslight-indigo-m-dot-color,var(--spectrum-global-color-indigo-400)
)}:host([variant=seafoam]):before{background-color:var(
--spectrum-statuslight-seafoam-m-dot-color,var(--spectrum-global-color-seafoam-400)
)}:host([variant=chartreuse]):before{background-color:var(
--spectrum-statuslight-chartreuse-m-dot-color,var(--spectrum-global-color-chartreuse-400)
)}:host([variant=magenta]):before{background-color:var(
--spectrum-statuslight-magenta-m-dot-color,var(--spectrum-global-color-magenta-400)
)}:host([variant=purple]):before{background-color:var(
--spectrum-statuslight-purple-m-dot-color,var(--spectrum-global-color-purple-400)
)}:host([disabled]):before{background-color:var(
--spectrum-statuslight-dot-color-disabled,var(--spectrum-global-color-gray-400)
)}
`;
export default styles;
//# sourceMappingURL=status-light.css.js.map